// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"c5670872","344":"582727c6","736":"c5ad6c90","842":"3f6ea870","902":"abeb6a00","940":"6fdbff8d"}[chunkId] + ".chunk.js";
};